<template>
    <div>
        <BoxAntecedentes :data="antecedentesData" />
        <BoxSubjetivo :data="subjetivoData" />
        <BoxObjetivo :data="objetivoData" />
        <BoxAvaliacao :data="avaliacaoData" />
        <BoxPlano :data="planoData" />

        <BoxFinalizacao
            :data="finalizacaoData"
            :fila-id="filaId"
        />
    </div>
</template>

<script>
// Components.
import BoxAntecedentes from './components/antecedente/Index'
import BoxAvaliacao from './components/avaliacao/Index'
import BoxFinalizacao from './components/finalizacao/Index'
import BoxObjetivo from './components/objetivo/Index'
import BoxPlano from './components/plano/Index'
import BoxSubjetivo from './components/subjetivo/Index'

export default {
    components: {
        BoxAntecedentes,
        BoxAvaliacao,
        BoxFinalizacao,
        BoxObjetivo,
        BoxPlano,
        BoxSubjetivo,
    },
    computed: {
        antecedentesData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.antecedentes,
                model: this.data.model.antecedentes,
                cidSugestao: this.cidSugestao,
            }
        },
        subjetivoData() {
            return {
                additionals: this.data.additionals,
                avaliacaoForm: this.data.form.avaliacao,
                avaliacaoModel: this.data.model.avaliacao,
                form: this.data.form.subjetivo,
                model: this.data.model.subjetivo,
                cidSugestao: this.cidSugestao,
            }
        },
        objetivoData() {
            return {
                additionals: this.data.additionals,
                avaliacaoModel: this.data.model.avaliacao,
                form: this.data.form.objetivo,
                model: this.data.model.objetivo,
            }
        },
        avaliacaoData() {
            return {
                additionals: this.data.additionals,
                finalizacaoForm: this.data.form.finalizacao,
                finalizacaoModel: this.data.model.finalizacao,
                form: this.data.form.avaliacao,
                model: this.data.model.avaliacao,
                objetivoModel: this.data.model.objetivo,
                cidSugestao: this.cidSugestao,
            }
        },
        planoData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.plano,
                model: this.data.model.plano,
                cidSugestao: this.cidSugestao,
            }
        },
        finalizacaoData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.finalizacao,
                model: this.data.model.finalizacao,
                cidSugestao: this.cidSugestao,
            }
        },
        cidSugestao() {

            const problemas = this.data.model.antecedentes.problemasCondicoes
                ? this.data.model.antecedentes.problemasCondicoes.filter(item => !item.id)
                : [];
            const motivos = this.data.model.subjetivo.motivos || [];
            const motivosForm = this.data.historicoSoap.subjetivo.motivos || [];
            const problemasCondicoes = this.data.model.avaliacao.problemasCondicoes || [];
            const problemasCondicoesForm = this.data.historicoSoap.avaliacao.problemasCondicoes || [];
            const solicitacoesExamesAltoCusto = this.data.model.plano.solicitacoesExamesAltoCusto || [];
            const solicitacoesExamesAltoCustoForm = this.data.historicoSoap.plano.solicitacoesExamesAltoCusto || [];
            const solicitacoesExamesComuns = this.data.model.plano.solicitacoesExamesComuns || [];
            const solicitacoesExamesComunsForm = this.data.historicoSoap.plano.solicitacoesExamesComuns || [];
            const atestados = this.data.model.plano.atestados || [];
            const atestadosForm = this.data.historicoSoap.plano.atestados || [];
            const encaminhamentos = this.data.model.plano.encaminhamentos || [];
            const encaminhamentosForm = this.data.historicoSoap.plano.encaminhamentos || [];
            const compartilhamentosCuidado = this.data.model.plano.compartilhamentosCuidado || [];
            const compartilhamentosCuidadosForm = this.data.historicoSoap.plano.compartilhamentosCuidados || [];
            const cidEmadForm = this.data.historicoSoap.finalizacao.cidEmad || [];
            const emadCidPrimarioId = this.data.model.finalizacao.emadCidPrimarioId

            const unicosProblemas = new Map();
            problemas.forEach(p => {
                if (p.cid && !unicosProblemas.has(p.cid.id)) {
                    unicosProblemas.set(p.cid.id, p);
                }
            });

            motivos.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            motivosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            problemasCondicoes.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            problemasCondicoesForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesAltoCusto.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesAltoCustoForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesComuns.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesComunsForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            atestados.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            atestadosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

           encaminhamentos.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            encaminhamentosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            compartilhamentosCuidado.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            compartilhamentosCuidadosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            if (emadCidPrimarioId) {
                emadCidPrimarioId['cid'] = {
                    codigo: emadCidPrimarioId.codigo,
                    id: emadCidPrimarioId.id,
                    nome: emadCidPrimarioId.nome
                }
            }

            if (emadCidPrimarioId && !unicosProblemas.has(emadCidPrimarioId.cid.id)) {
                unicosProblemas.set(emadCidPrimarioId.cid.id, emadCidPrimarioId);
            }

            cidEmadForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            return Array.from(unicosProblemas.values()).map(item => ({
                id: item.cid.id,
                codigoNome: item.cid.codigo + ' - ' + item.cid.nome,
                codigo: item.cid.codigo,
                nome: item.cid.nome
            }));
        }
    },
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
    },
}
</script>